<template>
  <div>
    <div class="main-header-left d-none d-lg-block">
      <div class="logo-wrapper my-3">
        <router-link to="/">
          <img
            src="../assets/images/white_logo.png"
            style="height: 50px"
            alt
          >
        </router-link>
      </div>
    </div>
    <div class="sidebar custom-scrollbar pt-5">
      <div
        v-if="user"
        class="sidebar-user text-center"
      >
        <div>
          <img
            class="img-60 rounded-circle bg-white shadow"
            :src="getImgUrl()"
            alt="#"
          >
          <img
            v-if="company?.systemVerifiedCompany===2"
            src="../assets/images/verified.svg"
            alt="Verified Icon"
            class="position-absolute top-0 start-100 translate-middle p-1 bg-white rounded-circle"
            style="width: 30px; height: 30px;"
          >
          <img
            v-else
            src="../assets/images/unverified.svg"
            alt="Unverified Icon"
            class="position-absolute top-0 start-100 translate-middle p-1 bg-white rounded-circle"
            style="width: 30px; height: 30px;"
          >
        </div>
        <div v-if="sessionType ==='personal'">
          <h6 class="mt-3 f-14">
            {{ user.name }} {{ user.surname }}
          </h6>
          <p>{{ user.uniqueId }}</p>
        </div>
        <div v-else>
          <h6 class="mt-3 mb-2 f-14">
            {{ company.name }} {{ getCompanyFormat(company.format) }}
          </h6>

          <ProfileTypeBadge
            :profile="profile"
            :badge-white="true"
          />
        </div>
      </div>


      <ul
        id="myDIV"
        class="sidebar-menu"
        :style="[layout.settings.sidebar.type === 'horizontal_sidebar' ? layout.settings.layout_type==='rtl'? {'margin-right': margin+'px'} : {'margin-left': margin+'px'} : { margin : '0px'}]"
      >
        <li
          class="left-arrow"
          :class="{'d-none': layout.settings.layout_type==='rtl'? hideLeftArrowRTL: hideLeftArrow}"
          @click="(layout.settings.sidebar.type === 'horizontal_sidebar' && layout.settings.layout_type==='rtl') ? scrollToLeftRTL() : scrollToLeft()"
        >
          <i class="fa fa-angle-left" />
        </li>


        <li class="menu-group-header">
          {{ $t('sidebar.sasShif') }}
        </li>
        <li class="menu-item">
          <router-link :to="{name:'welcome'}">
            <img
              src="../assets/images/icons/menu/dashboard.png"
              alt="-"
              class="menu-icon"
            >
            <span>{{ $t('sidebar.lvh') }}</span>
          </router-link>
        </li>

        <template v-if="sessionType==='company'">
          <li class="menu-group-header  mt-4">
            {{ $t('sidebar.irktDetallar') }}
          </li>
          <li
            v-if="profile === 'SUPPLIER'"
            class="menu-item"
          >
            <router-link :to="{name:'offers'}">
              <img
                src="../assets/images/icons/request/offer-svgrepo-com.svg"
                alt="-"
                class="menu-icon "
              >
              <span>Təkliflərim</span>
            </router-link>
          </li>
          <li class="menu-item">
            <router-link :to="{name:'companyProfile'}">
              <img
                src="../assets/images/icons/menu/company.png"
                alt="-"
                class="menu-icon"
              >
              <span>{{ $t('sidebar.irktProfili') }}</span>
            </router-link>
          </li>
          <li class="menu-item">
            <router-link :to="{name:'subscriptionPage'}">
              <img
                src="../assets/images/icons/menu/subscription.png"
                alt="-"
                class="menu-icon"
              >
              <span>{{ $t('sidebar.abunliyim') }}</span>
            </router-link>
          </li>
          <li class="menu-item">
            <router-link :to="{name:'invoicesPage'}">
              <img
                src="../assets/images/icons/menu/payments.png"
                alt="-"
                class="menu-icon"
              >
              <span>{{ $t('sidebar.dmlrim') }}</span>
            </router-link>
          </li>
          <li
            v-if="company.legalForm !== 'PERSONAL' "
            class="menu-item"
          >
            <router-link :to="{name:'companyBoard'}">
              <img
                src="../assets/images/icons/menu/company-board.png"
                alt="-"
                class="menu-icon"
              >
              <span>{{ $t('dashboardCompany.irktLvhsi') }}</span>
            </router-link>
          </li>
        </template>
        <li class="menu-group-header mt-4">
          {{ $t('sidebar.yardm') }}
        </li>
        <li class="menu-item">
          <router-link :to="{name:'faq'}">
            <img
              src="../assets/images/icons/menu/faq.png"
              alt="-"
              class="menu-icon"
            >
            <span>{{ $t('sidebar.teztezVerilnSuallar') }}</span>
          </router-link>
        </li>
        <li class="menu-item">
          <router-link :to="{name:'page', params:{slug: 'terms'}}">
            <img
              src="../assets/images/icons/menu/terms.png"
              alt="-"
              class="menu-icon"
            >
            <span>{{ $t('sidebar.rtlr') }}</span>
          </router-link>
        </li>
        <li class="menu-item">
          <router-link :to="{name:'page', params:{slug: 'privacy'}}">
            <img
              src="../assets/images/icons/menu/privacy.png"
              alt="-"
              class="menu-icon"
            >
            <span>{{ $t('sidebar.mxfilikSiyasti') }}</span>
          </router-link>
        </li>
        <li class="menu-item">
          <router-link :to="{name:'feedback'}">
            <img
              src="../assets/images/icons/menu/support.png"
              alt="-"
              class="menu-icon"
            >
            <span>{{ $t('sidebar.dstk') }}</span>
          </router-link>
        </li>


        <li class="menu-item mt-5 mb-2">
          <router-link :to="{name:'changeAccount'}">
            <img
              src="../assets/images/icons/menu/change-account.png"
              alt="-"
              class="menu-icon"
            >
            <span>{{ $t('sidebar.hesabDyi') }}</span>
          </router-link>
        </li>


        <li
          class="right-arrow"
          :class="{'d-none': layout.settings.layout_type==='rtl'? hideRightArrowRTL : hideRightArrow }"
          @click="(layout.settings.sidebar.type === 'horizontal_sidebar' && layout.settings.layout_type==='rtl') ? scrollToRightRTL() : scrollToRight()"
        >
          <i class="fa fa-angle-right" />
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import {mapState} from "vuex";
import {mediaBase} from "@/repositories/Repository";
import {getCompanyFormat} from "@/repositories/Utils";
import ProfileTypeBadge from "@/components/ProfileTypeBadge.vue";

export default {
  name: "Sidebar",
  components: {ProfileTypeBadge},
  data() {
    return {
      width: 0,
      height: 0,
      margin: 0,
      hideRightArrowRTL: true,
      hideLeftArrowRTL: true,
      hideRightArrow: true,
      hideLeftArrow: true,
      menuWidth: 0
    };
  },
  computed: {
    ...mapState({
      menuItems: state => state.menu.data,
      layout: state => state.layout.layout,
      sidebar: state => state.layout.sidebarType,
      user: state => state.auth.user,
      company: state => state.auth.company,
      sessionType: state => state.auth.sessionType,
      profile: state => state.auth.profile,
      position: state => state.auth.position,
    }),
  },
  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
    if (this.width < 991) {
      this.layout.settings.sidebar.type = "default";
    }
    const val = this.sidebar
    if (val === 'default') {
      this.layout.settings.sidebar.type = 'default';
      this.layout.settings.sidebar.body_type = 'default';
    } else if (val === 'compact') {
      this.layout.settings.sidebar.type = 'compact-wrapper';
      this.layout.settings.sidebar.body_type = 'sidebar-icon';
    } else if (val === 'compact-icon') {
      this.layout.settings.sidebar.type = 'compact-page';
      this.layout.settings.sidebar.body_type = 'sidebar-hover';
    } else if (val === 'horizontal') {
      this.layout.settings.sidebar.type = 'horizontal_sidebar';
      this.layout.settings.sidebar.body_type = '';
    }
    setTimeout(() => {
      const elmnt = document.getElementById("myDIV");
      this.menuWidth = elmnt.offsetWidth;
      this.menuWidth > window.innerWidth ? (this.hideRightArrow = false, this.hideLeftArrowRTL = false) : (this.hideRightArrow = true, this.hideLeftArrowRTL = true)
    }, 500)
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
  mounted() {
    this.menuItems.filter(items => {
      if (items.path === this.$route.path)
        this.$store.dispatch("menu/setActiveRoute", items);
      if (!items.children) return false;
      items.children.filter(subItems => {
        if (subItems.path === this.$route.path)
          this.$store.dispatch("menu/setActiveRoute", subItems);
        if (!subItems.children) return false;
        subItems.children.filter(subSubItems => {
          if (subSubItems.path === this.$route.path)
            this.$store.dispatch("menu/setActiveRoute", subSubItems);
        });
      });
    });
  },
  methods: {

    getImgUrl() {
      if (this.sessionType === 'company') {
        return (this.company && this.company.logo ? mediaBase + '/thumbnailCropped' + this.company.logo : require("../assets/images/dashboard/user.png"))
      } else {
        return (this.user && this.user.photo ? mediaBase + '/thumbnailCropped' + this.user.photo : require("../assets/images/dashboard/user.png"))
      }
    },
    setNavActive(item) {
      this.$store.dispatch("menu/setNavActive", item);
    },
    handleResize() {
      this.width = window.innerWidth - 310;
    },
    scrollToRightRTL() {
      this.temp = this.width + this.margin;
      // Checking condition for remaing margin
      if (this.temp === 0) {
        this.margin = this.temp;
        this.hideRightArrowRTL = true;
      }
      // else
      else {
        this.margin += this.width;
        this.hideRightArrowRTL = false;
        this.hideLeftArrowRTL = false;
      }
    },
    scrollToLeftRTL() {
      // If Margin is reach between screen resolution
      if (this.margin <= -this.width) {
        this.margin += -this.width;
        this.hideLeftArrowRTL = true;
      }
      //Else
      else {
        this.margin += -this.width;
        this.hideRightArrowRTL = false;
      }
    },
    scrollToLeft() {

      // If Margin is reach between screen resolution
      if (this.margin >= -this.width) {
        this.margin = 0;
        this.hideLeftArrow = true;
      }
      //Else
      else {
        this.margin += this.width;
        this.hideRightArrow = false;
      }
    },
    scrollToRight() {
      this.temp = this.menuWidth + this.margin;
      // Checking condition for remaing margin
      if (this.temp < this.menuWidth) {
        this.margin = -this.temp;
        this.hideRightArrow = true;
      }
      // else
      else {
        this.margin += -this.width;
        this.hideLeftArrow = false;
      }
    },
    getCompanyFormat(keyword) {
      return getCompanyFormat(keyword, this.$i18n.locale);
    },

    openFeedbackForm() {
      this.$bvModal.show('modal-feedback-form')
    }
  }
};
</script>

<style lang="scss">
.menu-group-header{
  font-size: 14px;
  color: rgba(255,255,255,0.5);
  margin-bottom: 10px;
  margin-left: 20px;
}
.menu-item{

  a {
    display: block;
    font-size: 14px;
    color: rgba(255, 255, 255, 1) !important;
    padding: 12px 20px;
    line-height: 24px;
    border-radius: 6px;

    .menu-icon{
      height: 24px;
      width: 24px;
      margin-right: 20px;
    }

    &:hover {
      padding: 12px 19px !important;
      background: rgba(255, 255, 255, 0.1) !important;
    }
  }
}
</style>
